const oktaConfig = {
  clientId: process.env.REACT_APP_CLIENT_ID,
  issuer: process.env.REACT_APP_OKTA_METADATA,
  redirectUri: process.env.REACT_APP_REDIRECT_URI,
  scopes: ["openid", "profile", "email", "offline_access"],
  dpop: true,
 
  tokenManager: {
    storage: 'localStorage',
    autoRenew: true,
    expireEarlySeconds: 300,
  }
};
 
export default oktaConfig;